<div class="fullcontainer">
  <app-workshop-nav></app-workshop-nav>
  <div>
    <br />
    <div class='titleContainer'>
      <h2 class='header'>Vehicle Check Areas</h2>
    </div>
    <br />

    <div class="row content-block">
      <div class="col">
        <table class='table table-bordered table-hover' >
          <thead class='thead-light'>
            <tr>
              <th>Name</th>
              <th>Vehicle Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (cat of this.categories; track cat) {
              <tr>
                <!-- <ng-container *ngIf='!this.addToggle'> -->
                <td>{{cat.name}}</td>
                @if (cat.vehicleTypeId === 0) {
                  <td colspan='2'>All Types</td>
                }
                @if (cat.vehicleTypeId > 0) {
                  <td colspan='2'>{{cat.vehicleType.name}}</td>
                }
                <!-- <td class='p-0 text-center'>
                <button
                  *ngIf='!this.disableButtons'
                  class='btn btn-warning m-0 btn-block'
                  (click)='this.editCategory(cat.id)'>
                  <i class="far fa-edit"></i>
                </button>
                <button
                  *ngIf='this.disableButtons'
                  class='btn btn-warning m-0 btn-block disabled'>
                  <i class="far fa-edit"></i>
                </button>
              </td> -->
            <!-- </ng-container> -->
          </tr>
        }
        <tr>
          @if (this.addToggle) {
            <td>
              <label>Name</label>
              <input type='text' [(ngModel)]='this.newRow.name' class='form-control'/>
            </td>
            <td>
              <label>Vehicle Type</label>
              <select
                class='form-control'
                [class.is-invalid]='this.newRow.vehicleTypeId === -1'
                [class.is-valid]='this.newRow.vehicleTypeId >= 0'
                (change)='this.newRow.vehicleTypeId = +$event.target.value;'
                >
                <option value='0'>All Types</option>
                @for (item of this.vehicleTypes; track item) {
                  <option
                    [value]='item.id'
                    [selected]='this.newRow.vehicleTypeId === item.id'>
                    {{ item.name }}
                  </option>
                }
              </select>
            </td>
            <td>
              <button class='btn btn-success' (click)='saveRow()'>Save</button>
            </td>
          }
        </tr>
        <tr>
          <td colspan='3'>
            @if (!disableButtons) {
              <button class='btn btn-secondary' (click)='addRow()'><i class="fas fa-plus"></i> New</button>
            }
            @if (disableButtons) {
              <button class='btn btn-secondary' disabled><i class="fas fa-plus"></i> New</button>
            }
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</div>
</div>
